export const debounce = (func, wait, immediate) => {
  let timeout;
  return function () {
    const context = this;
    const args = arguments;
    const later = () => {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

export function checkMobileOrDesktopHeader () {
  const headerDesktop = document.getElementById('page-header');
  const headerMobile = document.getElementById('page-header--mobile');
  let header;
  const isDisplayed = (element) => {
    const display = window.getComputedStyle(element).display;
    return display === 'block' || display === 'grid';
  };
  if (isDisplayed(headerDesktop)) {
    header = headerDesktop;
  } else if (isDisplayed(headerMobile)) {
    header = headerMobile;
  }
  return header;
}
